import { useRef, useState } from "react"

type EmojiTarget = HTMLInputElement | HTMLTextAreaElement

// Shared by the composer and the inline editor, so an emoji lands in the field whose own
// picker was opened.
export const useEmojiInsert = (value: string, onChange: (next: string) => void) => {
  const inputRef = useRef<EmojiTarget>(null)
  const [emojiAnchor, setEmojiAnchor] = useState<HTMLElement | null>(null)

  const toggleEmojiPicker = (trigger: HTMLElement) => {
    setEmojiAnchor((current) => (current ? null : trigger))
  }

  const closeEmojiPicker = () => {
    setEmojiAnchor(null)
    inputRef.current?.focus()
  }

  const insertEmoji = (emoji: string) => {
    const input = inputRef.current
    const selectionStart = input?.selectionStart ?? value.length
    const selectionEnd = input?.selectionEnd ?? value.length

    onChange(value.slice(0, selectionStart) + emoji + value.slice(selectionEnd))

    // The picker stays open, so the caret is walked past the emoji once it has rendered.
    requestAnimationFrame(() => {
      const caret = selectionStart + emoji.length

      input?.setSelectionRange(caret, caret)
    })
  }

  return { inputRef, emojiAnchor, toggleEmojiPicker, closeEmojiPicker, insertEmoji }
}
